import React from 'react';
import './form-layout.scss';

export type FormLayoutProps = {
  children: any[];
};

export function FormLayout(props: FormLayoutProps) {
  return (
    <div className="FormLayout">
      {props.children.map((child, index) => (
        <div className="layout-item" key={index}>
          {child}
        </div>
      ))}
    </div>
  );
}
